// @ts-nocheck
import { get, post } from "@insite/client-framework/Services/ApiService";
import { StoreWarehouseModel } from "@store/Framework/Types/ApiModels";

const storeWarehouseUrl = "/api/v1/warehouses/store";

export interface SetStoreWarehousesApiParameter {
    name: string;
}

export interface GetPickupWarehousesApiParameter {
    name: string;
}

export function getPickUpWarehouses() {
    return get<StoreWarehouseModel[]>(`${storeWarehouseUrl}/pickup`);
}

export function setCurrentWarehouse(parameter: SetStoreWarehousesApiParameter) {
    return post<StoreWarehouseModel>(`${storeWarehouseUrl}/setCurrentWarehouse?warehousename=${parameter.name}`);
}
